module.exports = __webpack_public_path__ + "img/darkrose.ba5a088f.png";